import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Loader from "../components/Loader";
import "../assets/variables.css";

const UserEmailPreferences = () => {
  const navigate = useNavigate();
  const { user: authUser } = useAuth();

  const [preferences, setPreferences] = useState({
    emails_receive_marketing: 0,
    emails_updates_by: 0,
    emails_share_data_other_organisations: 0,
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEmailPreferences();
  }, []);

  const fetchEmailPreferences = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/my-email-preferences`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch email preferences");
      }

      const result = await response.json();
      setPreferences(result.data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPreferences((prev) => ({
      ...prev,
      [name]: parseInt(value),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccess(false);
    setError(null);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/my-email-preferences`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(preferences),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update email preferences");
      }

      setSuccess(true);
      setTimeout(() => {
        navigate("/dashboard");
      }, 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="container">
        <Loader />
      </div>
    );
  }

  return (
    <div className="container">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/dashboard">Home</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Edit My Email Preferences
          </li>
        </ol>
      </nav>

      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-form">
            <div className="panel-title">
              <h3>Edit My Email Preferences</h3>
            </div>

            <div className="panel-group panel-body">
              {success && (
                <div className="alert alert-success" role="alert">
                  Email preferences updated successfully! Redirecting...
                </div>
              )}

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="form-horizontal">
                {/* Marketing Emails */}
                <fieldset>
                  <div className="form-group mb-3">
                    <label className="control-label col-sm-12 text-left">
                      I agree that I would like to receive promotional offers,
                      available property lists and other updates from Global
                      Guardians
                    </label>
                    <div className="col-md-12">
                      <label className="radio-inline">
                        <input
                          type="radio"
                          name="emails_receive_marketing"
                          value="0"
                          checked={preferences.emails_receive_marketing === 0}
                          onChange={handleChange}
                          className="form-checkbox"
                        />
                        {" No"}
                      </label>
                      <label className="radio-inline" style={{ marginLeft: "20px" }}>
                        <input
                          type="radio"
                          name="emails_receive_marketing"
                          value="1"
                          checked={preferences.emails_receive_marketing === 1}
                          onChange={handleChange}
                          className="form-checkbox"
                        />
                        {" Yes"}
                      </label>
                    </div>
                  </div>
                </fieldset>

                {/* Updates By */}
                <fieldset>
                  <div className="form-group mb-3">
                    <label className="control-label col-sm-12 text-left">
                      I would like to receive Global Guardians updates by:
                    </label>
                    <div className="col-sm-12">
                      <label className="radio-inline">
                        <input
                          type="radio"
                          name="emails_updates_by"
                          value="0"
                          checked={preferences.emails_updates_by === 0}
                          onChange={handleChange}
                          className="form-checkbox"
                        />
                        {" E-mail"}
                      </label>
                      <label className="radio-inline" style={{ marginLeft: "20px" }}>
                        <input
                          type="radio"
                          name="emails_updates_by"
                          value="1"
                          checked={preferences.emails_updates_by === 1}
                          onChange={handleChange}
                          className="form-checkbox"
                        />
                        {" Phone"}
                      </label>
                      <label className="radio-inline" style={{ marginLeft: "20px" }}>
                        <input
                          type="radio"
                          name="emails_updates_by"
                          value="2"
                          checked={preferences.emails_updates_by === 2}
                          onChange={handleChange}
                          className="form-checkbox"
                        />
                        {" Letter"}
                      </label>
                    </div>
                  </div>
                </fieldset>

                {/* Share Data */}
                <fieldset>
                  <div className="form-group mb-3">
                    <label className="control-label col-sm-12 text-left">
                      I agree that Global Guardians can share my contact
                      information with other organisations
                    </label>
                    <div className="col-md-12">
                      <label className="radio-inline">
                        <input
                          type="radio"
                          name="emails_share_data_other_organisations"
                          value="0"
                          checked={
                            preferences.emails_share_data_other_organisations === 0
                          }
                          onChange={handleChange}
                          className="form-checkbox"
                        />
                        {" No"}
                      </label>
                      <label className="radio-inline" style={{ marginLeft: "20px" }}>
                        <input
                          type="radio"
                          name="emails_share_data_other_organisations"
                          value="1"
                          checked={
                            preferences.emails_share_data_other_organisations === 1
                          }
                          onChange={handleChange}
                          className="form-checkbox"
                        />
                        {" Yes"}
                      </label>
                    </div>
                  </div>
                </fieldset>

                {/* Submit Button */}
                <fieldset className="form-horizontal">
                  <div className="form-group text-right">
                    <div className="col-sm-3"></div>
                    <div className="col-sm-5">
                      <button
                        type="submit"
                        className="btn btn-head btn-standard"
                        disabled={saving}
                      >
                        {saving ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Saving...
                          </>
                        ) : (
                          <>
                            <i className="glyphicon glyphicon-ok"></i> Save
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEmailPreferences;
